export default __webpack_public_path__ + "static/media/cz2.e1941e5a.svg";